export default {
    DCA: "inindca.com",
    TCA: "inintca.com",
    COM: "mypurecloud.com",
    AU: "mypurecloud.com.au",
    IE: "mypurecloud.ie",
    JP: "mypurecloud.jp",
    DE: "mypurecloud.de",
};
